export default "__VITE_ASSET__BGv1Wu_8__"